module.exports = __webpack_public_path__ + "img/s2.cb806a10.jpg";